import { parseClient, getRates, formatDate, assignAccess, getClients, getConfig, getCurrencyList } from './Utils.js';
import Nav from './Nav.js';
import LoginEntryPage from './LoginEntryPage';
import { getLoginRedirectOptionsForIdentifier, getSsoLoginOptions } from './Auth/ssoRouting';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import React, { Component } from 'react';
import {Column,Row} from './Header.js';
import jwt_decode from 'jwt-decode';
import Cell from './Cell.js';
import axios from 'axios';
import './Currency.css';
import { AUTH_CONFIG } from './Auth/auth0-variables';

class Currency extends Component {

  constructor(props) {
    super(props);
    this.state = {
      clientList: '',
      username: '',
      profile_client: '',
      client_id: '',
      usd_rate: undefined,
      cad_rate: undefined,
      eur_rate: undefined,
      gbp_rate: undefined,
      client_list: ['SKY'],
      ending_date: '2017-12-05',
      modified_by: '',
      modified_date: '',
      rate_list : '',
      text: '',
      config: undefined,
      access_token: undefined,
      currency_list: {},
      newCurrency_flag: false,
      newCurrency_flag2: true,
      newCurrency: undefined,
      silentAuthStatus: 'idle',
    }

    this.baseState = this.state;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.createCellGroup = this.createCellGroup.bind(this);
    this.createCellGroups = this.createCellGroups.bind(this);
    this.addCurrency = this.addCurrency.bind(this);
    this.newCurrencyGroup = this.newCurrencyGroup.bind(this);
    this.attemptSilentAuth = this.attemptSilentAuth.bind(this);

  }

  handleChange(e) {
    if (e.value){
      if (e.value.indexOf('NewCurrencyDropdown') >= 0) {
        var items = Object.keys(this.state.rate_list);
        var newCurrency = [];
        newCurrency[e.label] = "None,None,None,None";

        for (var item, i = 0; item = items[i++];) {
          newCurrency[item] = this.state.rate_list[item];
        }

        this.setState({
          rate_list: newCurrency,
          newCurrency_flag: false,
          newCurrency_flag2: false
        });
      }else{
        this.initRateList(e.value, this.state.access_token);
        this.setState({client_id:e.value});
      }
    }else if(e.target.value) {
        var update_usd_rate,update_cad_rate,update_eur_rate,update_gbp_rate;
        switch(e.target.id.slice(-3)){
          case 'USD':
            update_usd_rate = this.state.usd_rate;
            update_usd_rate[e.target.id.slice(0,3)] = e.target.value;
            this.setState(update_gbp_rate);
            this.setState(update_eur_rate);
            this.setState(update_cad_rate);
            this.setState(update_usd_rate);
            break;
          case 'CAD':
            update_cad_rate = this.state.cad_rate;
            update_cad_rate[e.target.id.slice(0,3)] = e.target.value;
            this.setState(update_gbp_rate);
            this.setState(update_eur_rate);
            this.setState(update_cad_rate);
            this.setState(update_usd_rate);
            break;
          case 'EUR':
            update_eur_rate = this.state.eur_rate;
            update_eur_rate[e.target.id.slice(0,3)] = e.target.value;
            this.setState(update_gbp_rate);
            this.setState(update_eur_rate);
            this.setState(update_cad_rate);
            this.setState(update_usd_rate);
            break;
          case 'GBP':
            update_gbp_rate = this.state.gbp_rate;
            update_gbp_rate[e.target.id.slice(0,3)] = e.target.value;
            this.setState(update_gbp_rate);
            this.setState(update_eur_rate);
            this.setState(update_cad_rate);
            this.setState(update_usd_rate);
            break;
          default:
            console.log("Default Case")
        }
    }
  }

  handleSubmit(e) {
    // Clear Values
    var count = 0
    var updatesMade = 0;

    Object.keys(this.state.usd_rate).forEach((key) => {
      if (this.state.usd_rate[key] !== ''){
        updatesMade++;
      }

      else if (this.state.cad_rate[key] !== ''){
        updatesMade++;
      }

      else if (this.state.eur_rate[key] !== ''){
        updatesMade++;
      }

      else if (this.state.gbp_rate[key] !== ''){
        updatesMade++;
      }

    });


    Object.keys(this.state.usd_rate).forEach((key) => {
      if (this.state.usd_rate[key] !== '' ||
        this.state.cad_rate[key] !== '' ||
        this.state.eur_rate[key] !== '' ||
        this.state.gbp_rate[key] !== '') {
        axios.create({
          baseURL: AUTH_CONFIG.baseUrl,
          headers : {
            Authorization : "Bearer " + this.state.access_token
          },
          timeout: 3000,
          params: {
            client_id: this.state.client_id,
            currency: key,
            usd_rate: this.state.usd_rate[key],
            cad_rate: this.state.cad_rate[key],
            eur_rate: this.state.eur_rate[key],
            gbp_rate: this.state.gbp_rate[key],
            modified_date: this.state.modified_date,
            modified_by: this.state.modified_by
          }
        })
        .post('/load').then((response) => {
          count++;
          console.log(response);
          if(count === updatesMade){
            alert("All items updated!");
            window.location.reload();
          }
        }).catch((error) => {
          console.log(error);
        });
        e.preventDefault();
      }
    });



  }

  initializeAfterAuth() {
    var id_tok = jwt_decode(localStorage.getItem('id_token'));
    var access_tok = localStorage.getItem('access_token');
    var groups = 'http://skypad_user/groups';

    this.isSSOAuthenticated(id_tok.nonce);
    this.setState({
      username: id_tok.name,
      client_id: parseClient(id_tok[groups]),
      profile_client: parseClient(id_tok[groups]),
      modified_by: id_tok.nickname,
      modified_date: formatDate(Date.now()),
      access_token: access_tok
    }, () => {
      this.initRateList(parseClient(id_tok[groups]), access_tok);
    });

    getConfig(access_tok).then(result => {
      this.setState({config:result});
    });

    getCurrencyList(access_tok).then(result => {
      var initCurrency1 = {};var initCurrency2 = {};var initCurrency3 = {};var initCurrency4 = {};

      Object.keys(result.data).forEach((key) => {
        initCurrency1[key] = '';
        initCurrency2[key] = '';
        initCurrency3[key] = '';
        initCurrency4[key] = '';
      });

      this.setState({currency_list:result.data});
      this.setState({usd_rate:initCurrency1});
      this.setState({cad_rate:initCurrency2});
      this.setState({eur_rate:initCurrency3});
      this.setState({gbp_rate:initCurrency4});
    });

    if (parseClient(id_tok[groups]) === 'SKY') {
      console.log('Getting clients..');
      getClients(access_tok).then(result => {
        this.setState({clientList:result});
      });
    } else {
      console.log('Not getting clients..');
    }
  }

  componentDidMount() {
    if (localStorage.getItem('id_token') === null) {
      const hashParams = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      const isCallbackInProgress = window.location.hash && window.location.hash.indexOf('access_token') >= 0;
      if (!hashParams.get('error')) {
        this.props.auth.handleAuthentication();
      }
      if (!isCallbackInProgress && !hashParams.get('error')) {
        this.attemptSilentAuth();
      }
      // If hash has an error, leave it intact so LoginEntryPage can read it
    } else {
      this.initializeAfterAuth();
    }
  }

  attemptSilentAuth() {
    if (this._silentAuthAttempted) {
      return;
    }
    this._silentAuthAttempted = true;
    this.setState({ silentAuthStatus: 'trying' });
    this.props.auth.checkSilentSession(
      () => {
        // Tokens are now in localStorage. Trigger a re-render; componentDidUpdate
        // already detects isAuthenticated() flipping true and calls
        // initializeAfterAuth() (see componentDidUpdate above) — no need to call it here.
        this.setState({ silentAuthStatus: 'succeeded' });
      },
      (err) => {
        // Developer-facing only (never shown to the user) — the specific error
        // (login_required, consent_required, timeout, ...) explains why the
        // shared SSO session wasn't picked up.
        console.warn('[silent-auth] checkSession failed:', err);
        if (err && err.error === 'consent_required') {
          // A shared SSO session exists but this app needs one one-time,
          // per-session interactive consent click before checkSession() will
          // succeed. Redirect straight to Auth0 instead of our own login page.
          try {
            this.props.auth.login();
          } catch (e) {
            this.setState({ silentAuthStatus: 'failed' });
          }
          return;
        }
        this.setState({ silentAuthStatus: 'failed' });
      }
    );
  }

  componentDidUpdate() {
    // After Auth0 callback, handleAuthentication() writes tokens to localStorage
    // and calls history.replace('/'), which re-renders but does NOT remount.
    // Detect that transition here: auth is valid but state hasn't been populated yet.
    if (this.props.auth.isAuthenticated() && !this.state.access_token) {
      this.initializeAfterAuth();
    }
  }

  login() {
    this.props.auth.login();
  }

  async handleLogin(identifier) {
    var trimmedIdentifier = String(identifier || '').trim();
    var isEmail = trimmedIdentifier.indexOf('@') >= 0;

    // Server-side check: look up the user in Auth0 to confirm SSO connection.
    // Needed for SSO users who enter their username instead of their company email.
    var checkResult = null;
    try {
      var res = await fetch('/api/auth/check-sso?username=' + encodeURIComponent(trimmedIdentifier));
      if (res.ok) {
        checkResult = await res.json();
      }
    } catch (e) {
      // Network error — fall through to client-side routing
    }

    if (checkResult && checkResult.ssoRequired) {
      if (isEmail) {
        this.props.auth.login({ connection: checkResult.connection, login_hint: trimmedIdentifier });
        return;
      } else {
        // SSO user entered a username — block and ask for company email
        throw new Error('Your company has enabled single sign-on (SSO). Please enter your company email address to login.');
      }
    }

    // No existing Auth0 identity found for this identifier (or check-sso was
    // inconclusive/unreachable) — fall back to the domain policy config
    // instead of assuming SSO isn't available. Auth0 only creates a profile
    // for a user after their first successful SSO login (JIT provisioning),
    // so this is the only way a first-time SSO user can ever reach their IdP.
    var resolved = trimmedIdentifier
      ? getLoginRedirectOptionsForIdentifier(trimmedIdentifier)
      : getSsoLoginOptions();

    if (isEmail && resolved.mode !== 'sso') {
      throw new Error('Your company has not enabled single sign-on (SSO). Please enter your SKYPAD username.');
    }

    this.props.auth.login(resolved.options || {});
  }

  renewSession() {
    this.props.auth.renewSession();
  }

  isSuperUser() {
    return assignAccess(this.state.client_id);
  }

  updateRateList(client_id_param){

    if (Object.keys(this.state.rate_list).length === 0){
      let rateList = getRates(client_id_param, this.state.access_token);
      rateList.then((values) => {

        this.setState({rate_list: values});

      });
    }
  }

  initRateList(client_id_param, access_token){
    let rateList = getRates(client_id_param, access_token);
    rateList.then((values) => {
      this.setState({rate_list: values});
      });
  }

  logout() {
    this.props.auth.logout();
  }

  isSSOAuthenticated(id_tok_nonce){
    this.props.auth.isSSOAuthenticated(id_tok_nonce);
  }

  checkForSkyUser(){
    return (this.state.profile_client === 'SKY');
  }

  createCellGroup(rate){
    var rateDescMap = this.state.currency_list;

    return (
      <div className="input-group">
        <Row header={rateDescMap[rate]} from={rate} client_id={this.state.client_id} rate_list={this.state.rate_list}></Row>
        <Cell from={rate} to="USD" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={this.state.config}></Cell>
        <Cell from={rate} to="CAD" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={this.state.config}></Cell>
        <Cell from={rate} to="EUR" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={this.state.config}></Cell>
        <Cell from={rate} to="GBP" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={this.state.config}></Cell>
      </div>);
  }

  newCurrencyGroup(rate) {
    var rateDescMap = this.state.currency_list;

    return (
      <div className="input-group">
        <Row header={rateDescMap[rate]} from={rate} client_id={this.state.client_id} rate_list={this.state.rate_list}></Row>
        <Cell from={rate} to="USD" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={{rate:"1,1,1,1"}}></Cell>
        <Cell from={rate} to="CAD" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={{rate:"1,1,1,1"}}></Cell>
        <Cell from={rate} to="EUR" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={{rate:"1,1,1,1"}}></Cell>
        <Cell from={rate} to="GBP" rate_list={this.state.rate_list} client_id={this.state.client_id} onChange={this.handleChange.bind(this)} config={{rate:"1,1,1,1"}}></Cell>
      </div>);
  }

  createCellGroups(groups){
    return groups.map(this.createCellGroup);
  }

  addCurrency(){
    this.setState({newCurrency_flag:true});
  }

  render() {
    {
    const { isAuthenticated } = this.props.auth;

    if (!isAuthenticated()) {
      // Auth0 error callback (e.g. access_denied): the error lands in the URL
      // hash or query. Render LoginEntryPage so it can display the message —
      // silent auth is deliberately skipped in this case, so silentAuthStatus
      // stays 'idle' and the guard below would otherwise blank the screen.
      const errorInUrl =
        new URLSearchParams(window.location.search || '').get('error') ||
        new URLSearchParams((window.location.hash || '').replace(/^#/, '')).get('error');

      if (!errorInUrl) {
        // Auth0 token callback: tokens are in the URL hash — wait for componentDidMount to process them
        if (window.location.hash && window.location.hash.indexOf('access_token') >= 0) {
          return null;
        }
        // Don't flash LoginEntryPage while the silent-auth attempt is in flight
        // (status 'idle' briefly before componentDidMount runs, or 'trying' while
        // checkSession() resolves).
        if (this.state.silentAuthStatus !== 'failed') {
          return null;
        }
      }
      return (
        <LoginEntryPage onSubmit={this.handleLogin.bind(this)} />
      );
    }

    var clientList = this.state.clientList;
    var currency_flag = this.state.newCurrency_flag;
    var newCurrencyOptions = []


    if (this.state.currency_list) {
      Object.keys(this.state.currency_list).forEach((item) => {
        if (Object.keys(this.state.rate_list).indexOf(item) < 0) {
          newCurrencyOptions.push({value:item + 'NewCurrencyDropdown', label:item})
        }
      });
    }

    return (
      <div className="container-fluid">

        {
          <Nav is_auth ={isAuthenticated()} user={this.state.username} client={this.state.profile_client}
            login={this.login.bind(this)} logout={this.logout.bind(this)}></Nav>
        }
        {
            isAuthenticated() && (

            <form className="card form-signin" onSubmit={this.handleSubmit}>
              {assignAccess(this.state.client_id)}
              <div>
              <img alt='skypadlogo' width="250" src="https://red.skypad.biz/qlikview/images/SKYPAD%20Logo.png"/>
              </div>
              <h3 className="form-signin-heading">
                <b>Currency Converter</b>
              </h3>
              <div hidden={clientList === ''}>
               <Dropdown className="react-dropdown" options={clientList} onChange={this.handleChange} value={this.state.client_id} placeholder="Select a client"/>
              </div>

              <br></br>
              <div hidden={clientList === ''}>
              <input
                style={{width:'150px'}}
                type="button"
                className="btn btn-primary pull-right"
                value="Add Currency"
                onClick={this.addCurrency}/>
              </div>
              <div hidden={!currency_flag}>
              <br></br>
               <Dropdown className="react-dropdown" options={newCurrencyOptions} onChange={this.handleChange} placeholder="Select a Currency"/>
              </div>
              <br></br>
              <br></br>

              <div className="input-group">
                <Row header='Currency' client_id={this.state.client_id}></Row>
                <Column header='USD' client_id={this.state.client_id} rate_list={this.state.rate_list} config={this.state.config}></Column>
                <Column header='CAD' client_id={this.state.client_id} rate_list={this.state.rate_list} config={this.state.config}></Column>
                <Column header='EUR' client_id={this.state.client_id} rate_list={this.state.rate_list} config={this.state.config}></Column>
                <Column header='GBP' client_id={this.state.client_id} rate_list={this.state.rate_list} config={this.state.config}></Column>
              </div>

              {this.createCellGroups(Object.keys(this.state.rate_list))}

              <br/>



              <input style={{width:'150px'}}
                type="submit"
                className="btn btn-primary btn-submit px-5" />

            </form>
          )
        }

      </div>
    );
  }
}
}

export default Currency;
